<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="取消原因"
              prop="driverApplyRemark"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.driverApplyRemark"
                type="textarea"
                disabled
                autosize
                :row="3"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="备注"
              prop="shipperDealRemark"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.shipperDealRemark"
                type="textarea"
                :row="3"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="allowFunc"
      >
        同 意
      </el-button>
      <el-button
        type="primary"
        @click="rejectFunc"
      >
        拒 绝
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      pageType: "cancelAffirm",
      form: {
        shipperDealRemark: "",
        driverApplyRemark: "",
        isCancel: 2
      },
      rules: {
        driverApplyRemark:[
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符"
          }
        ],
        shipperDealRemark: [
          { required: true, message: "请输入备注", trigger: "blur" },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    init(entity) {
      this.form.code = entity.code;
      this.form.shipperDealRemark = entity.shipperDealRemark;
      this.form.driverApplyRemark = entity.driverApplyRemark;
    },
    rejectFunc() {
      this.form.isCancel = 3;
      this.funcSubmit();
    },
    allowFunc() {
      this.form.isCancel = 2;
      this.funcSubmit();
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "ntocc-tms-api/orderDetail/driverCancelOrder",
            method: "put",
            params: data
          })
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  float: right;
}
</style>
